<template>
  <v-dialog v-model="showDialog" max-width="1150px">
    <v-card>
      <v-card-text>
        <data-log
          :headers="headers"
          :logData="logData"
          :title="title"
          :isLoading="isLoading"
          :csvFilename="csvFilename"
          :itemsPerPage="5"
          :showClose="true"
          :courseId="courseId"
          @closeEvent="closeDialog()"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { csvExport } from '../Constants'
import DataLog from '@/components/DataLog.vue'

export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    logData: {
      type: Array,
      required: true
    },
    showDialog: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    csvFilename: {
      type: String,
      default: 'download',
      required: false
    },
    courseId: {
      type: Number,
      required: false,
      default: null
    }
  },
  components: {
    DataLog
  },
  methods: {
    closeDialog() {
      this.showDialog = false
      this.$emit('closeDialogEvent')
    }
  }
}
</script>

<style></style>
